
const { fetch: origFetch } = window;
window.fetch = async (...args) => {
    const response = await origFetch(...args);
    if (response.url.includes('/tools/sparklayer/graphql')) {

        response
            .clone()
            .json()
            .then(data => {
                try {
                    if (data.data && data.data.updateCart != null) {
                        if (args.length > 1 && args[1].body) {
                            try {
                                const body = JSON.parse(args[1].body);
                                if (body.variables && body.variables.products) {
                                    window.dispatchEvent(new CustomEvent('sm-cart-updated', { detail: { cart: data.data.updateCart.cart } }));
                                    SmiffysCartQuantityLoader.getCart(data.data.updateCart.cart)
                                        .then(skuStock =>SmiffysCartQuantityLoader.updateUi(skuStock));
                                    
                                }
                            } catch { }
                        }
                    }
                } catch { }
            })
            .catch(err => console.error(err));
    }

    return response;
};


class SmiffysCartQuantityLoader {

    async init() {
        console.log("Loading Smiffys Cart Quantity Updates");
        SmiffysCartQuantityLoader.getCartAndUpdateUi();
    }

    static async getCartAndUpdateUi() {
        const skuStock = await SmiffysCartQuantityLoader.getCart();
        SmiffysCartQuantityLoader.updateUi(skuStock);
    }

    static async getCart(cart) {
        cart = cart || await window.spark.getCart();
        if (!cart) {
            return;
        }
        const skuStockMultiple = cart.items.map(x => { return { sku: x.sku, quantity: x.quantity } });
        let skuStock = [];
        skuStockMultiple.forEach((i) => {
            let foundItems = skuStock.find(x => x.sku == i.sku);
            if (foundItems) {
                foundItems.quantity = foundItems.quantity + i.quantity;
            } else {
                skuStock.push({ sku: i.sku, quantity: i.quantity });
            }
        });
        return skuStock;
    }

    static updateUi(cart) {
        for (const p of document.querySelectorAll('.product__quantity-cart-items p')) {
            const sku = p.getAttribute('data-sku');
            if (sku) {
                let cartItem = cart.find(x => x.sku == sku);
                p.innerHTML = cartItem ? cartItem.quantity.toString() : "0";

                let button = p.closest('td').querySelector('.empty-cart-button');
                if (button) {
                    button.innerHTML = "Remove";
                    button.setAttribute("data-action", "remove");
                    if (cartItem && cartItem.quantity) {
                        button.classList.remove('hidden');
                    } else {
                        button.classList.add('hidden');
                    }
                }
            }
        }
    }

    async cartQuantityButtonClick(event, sku) {
        event.preventDefault();
        let button = event.target;
        switch (button.getAttribute('data-action')) {
            case 'remove': {
                if (window.spark) {
                    const skuCartItems = await SmiffysCartQuantityLoader.getCart();
                    const cartItem = skuCartItems.find(x => x.sku == sku);
                    if (cartItem && cartItem.quantity > 0) {
                        const products = {
                            products: [
                                {
                                    sku: sku,
                                    adjustQuantity: cartItem.quantity * -1
                                }
                            ],
                            clearCart: false,
                        };
                        window.spark.updateCart(products);
                    }
                }
                break;
            }
            case 'load': {
                if (window.spark) {
                    SmiffysCartQuantityLoader.getCartAndUpdateUi();
                }
                break;
            }
        }

    }
    
    waitForSpaklayer(method, retryCount) {        
        if (window.spark) {
            method();
        } else {
            if (retryCount > 0) {
                console.log("retryCount", retryCount);
                setTimeout(() => this.waitForSpaklayer(method, --retryCount), 300);
            } else {
                console.log("SmiffysCartQuantityLoader failed to find Spark layer");
            }
        }
    }
}

const smiffysCartQuantityLoader = new SmiffysCartQuantityLoader();
smiffysCartQuantityLoader.waitForSpaklayer(smiffysCartQuantityLoader.init, 100);